import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Banner, Box, Button, Checkbox, Chip, Dialog, DialogContent, DialogFooter, DialogHeader, Typography, } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { MetadataSection } from './MetadataSection';
import { useGeSyncMetadataMock } from './useGeSyncMetadataMock';
export function SendToHubspotDialog(props) {
    const { onClose } = props;
    const { details, custom, standard } = useGeSyncMetadataMock();
    const allFieldIds = [...details.map((r) => r.id), ...custom.map((r) => r.id), ...standard.map((r) => r.id)];
    const [selectedIds, setSelectedIds] = useState(() => new Set());
    const allSelected = allFieldIds.length > 0 && selectedIds.size === allFieldIds.length;
    const someSelected = selectedIds.size > 0 && selectedIds.size < allFieldIds.length;
    const toggleAll = () => {
        if (allSelected) {
            setSelectedIds(new Set());
        }
        else {
            setSelectedIds(new Set(allFieldIds));
        }
    };
    const toggleOne = (id) => {
        setSelectedIds((prev) => {
            const next = new Set(prev);
            if (next.has(id)) {
                next.delete(id);
            }
            else {
                next.add(id);
            }
            return next;
        });
    };
    const handleSend = () => {
        // TODO
        onClose();
    };
    const renderRow = (row) => (<Box key={row.id} alignItems="center" gap="md" justifyContent="space-between">
      <Checkbox checked={selectedIds.has(row.id)} onChange={() => toggleOne(row.id)} label={row.label}/>
      <Chip label={row.value} size="small" appearance="secondary"/>
    </Box>);
    return (<Dialog onClose={onClose} size="md">
      <DialogHeader icon={<Falcon icon="hubspot" sourceConfig={{ family: 'classic', style: 'brands' }}/>} title={t({
            message: 'Send metadata values to HubSpot',
            comment: 'HubSpot metadata: dialog title',
        })}/>
      <DialogContent>
        <Box flexDirection="column" gap="xl" pb="3xl">
          <Typography>
            <Trans comment="HubSpot metadata: dialog content">Select which properties to sync to HubSpot.</Trans>
          </Typography>
          <Checkbox checked={allSelected} indeterminate={someSelected} onChange={toggleAll} label={t({
            message: 'Select all',
            comment: 'HubSpot metadata: select all fields',
        })}/>

          <MetadataSection title={t({ message: 'Document details', comment: 'HubSpot metadata: document details section title' })}>
            {details.map(renderRow)}
          </MetadataSection>

          {custom.length > 0 && (<MetadataSection title={t({ message: 'Custom metadata', comment: 'HubSpot metadata: custom metadata section title' })}>
              {custom.map(renderRow)}
            </MetadataSection>)}

          {standard.length > 0 && (<MetadataSection title={t({ message: 'Standard metadata', comment: 'HubSpot metadata: standard metadata section title' })}>
              {standard.map(renderRow)}
            </MetadataSection>)}
        </Box>

        <Banner appearance="info">
          <Falcon icon="exclamation-triangle"/>
          <Trans comment="HubSpot metadata: overwrite warning">
            Existing values in the selected HubSpot properties will be overwritten.
          </Trans>
        </Banner>
      </DialogContent>
      <DialogFooter>
        <Button size="xs" appearance="secondary" onClick={onClose}>
          <Trans comment="HubSpot metadata: cancel dialog">Cancel</Trans>
        </Button>
        <Button size="xs" appearance="primary" onClick={handleSend} disabled={selectedIds.size === 0}>
          <Trans comment="HubSpot metadata: confirm send">Send to HubSpot</Trans>
        </Button>
      </DialogFooter>
    </Dialog>);
}
